import { useCallback } from 'react';
import { BaseChoroplethMap } from '../../../components/Charts';
import { useProvincesChoroplethQuery } from '../hooks/useProvincesQuery';
import { geoJsonApi } from '../../../services';

interface ProvincesChoroplethProps {
	height?: number;
	fullHeight?: boolean;
}

export function ProvincesChoropleth({ height = 800, fullHeight = false }: ProvincesChoroplethProps) {
	const loadGeoJson = useCallback(() => geoJsonApi.getNormalizedProvinces(), []);

	return (
		<BaseChoroplethMap
			height={height}
			fullHeight={fullHeight}
			mapKey="vietnam"
			titlePrefix="Bản đồ Phân bố Sinh viên"
			infoTooltip="Sử dụng con lăn chuột để phóng to/thu nhỏ bản đồ"
			errorMessage="Có lỗi xảy ra khi tải dữ liệu bản đồ"
			geoJsonErrorMessage="Không thể tải dữ liệu bản đồ"
			loadGeoJson={loadGeoJson}
			useChoroplethQuery={useProvincesChoroplethQuery}
		/>
	);
}

